"use strict";

import Form from "../utils/Form";

class CarDetail {
  constructor() {
    $("select").selectric();

    new Form().done((data) => {
      if (data.status == 200) {
		var str=location.pathname;
		if (str.charAt(str.length - 1) !== '/') {
			str = str + '/';
		}
		location.href = location.origin + str + "completado/" + location.search;
      }
    });

    $(".colorList a").on("click", function(e) {
      e.preventDefault();
      $(".colorList li").removeClass("active");
      $(this)
        .closest("li")
        .addClass("active");

      $("section.colors")
        .find(".color")
        .text(
          $(this)
            .data("name")
            .toUpperCase()
        );
      $("section.colors")
        .find(".availableModels")
        .text($(this).data("models"));

      //console.log(`${App.baseUrl}/img/360/${$(this).data().model}/${$(this).data().color}/`);

      $("#cont360").vc3dEye({
        imagePath: `${App.baseUrl}/img/360/${$(this).data().dir}/${
          $(this).data().color
        }/`,
        totalImages: 36,
        imageExtension: "png",
        clickLeft: $(".colors .leftArrow"),
        clickRight: $(".colors .rightArrow"),
      });
    });
    $("#cont360").show();
    $(".colorList a:first").trigger("click");

    $("section.features").each(function() {
      var features = $(this)
        .find(".sliderCont")
        .bxSlider({
          mode: "fade",
          pager: false,
          controls: false,
          auto: true,
          stopAutoOnClick: true,
          adaptiveHeight: true,
          preventDefaultSwipeY: false,
          shrinkItems: true,
          onSliderLoad: function() {
            
          }

        });


       
      $(this).data("features", features);

      $(this)
        .find(".arrow.right")
        .on("click", function(e) {
          e.preventDefault();
          var features = $(this)
            .closest("section")
            .data("features");
          features.stopAuto();
          features.goToNextSlide();
          features.stopAuto();
        });
      $(this)
        .find(".arrow.left")
        .on("click", function(e) {
          e.preventDefault();
          var features = $(this)
            .closest("section")
            .data("features");
          features.stopAuto();
          features.goToPrevSlide();
          features.stopAuto();
        });
    });

    $("#exterior").on("click", function(e) {
      e.preventDefault();
      $(".slideshow.galleria_exterior").fadeIn();
    });

    $("#interior").on("click", function(e) {
      e.preventDefault();
      $(".slideshow.galleria_interior").fadeIn();
    });

    $(".slideshow .close").on("click", function(e) {
      e.preventDefault();
      $(this)
        .closest(".slideshow")
        .fadeOut();
    });

    $(".specs .seeMore").on("click", function(e) {
      e.preventDefault();
      var trim = $(this).data("trim");
      $.getJSON(
        App.baseUrl +
          "/ajax/car_detail/specs/" +
          $(this)
            .closest(".specs")
            .data("model") +
          "/" +
          trim,
        function(data) {
          if (data.success) {
            $("body").addClass("showOverlay");
            $(".specsModal").remove();

            $("section.specs").after(data.specs);
            $(".specsModal .close").on("click", function(evt) {
              evt.preventDefault();
              $("body").removeClass("showOverlay");
              $(".specsModal").fadeOut();
            });
            $(".specTitle").on("click", function(e) {
              $(this).toggleClass("open");
              $(this)
                .closest(".container")
                .find(".list")
                .slideToggle();
            });

            $(".specsModal").fadeIn();
          }
        }
      );
    });

    var slideWidth;
    if ($(window).width() > 1600) {
      slideWidth = 600;
    } else if ($(window).width() > 1440) {
      slideWidth = 520;
    } else if ($(window).width() > 992) {
      slideWidth = 500;
    } else {
      slideWidth = 314;
    }

    if ($(window).width() > 1600) {
      var tech = $("section.tech .slider.desktop").bxSlider({
        slideWidth,
        minSlides: 3,
        maxSlides: 4,
        moveSlides: 1,
        pager: true,
        controls: false,
        slideMargin: 0,
        shrinkItems: true,
        infiniteLoop: true,
        auto: false,
        preventDefaultSwipeY: false,
      });

      $("section.tech .controls .right").on("click", function(e) {
        e.preventDefault();
        tech.goToNextSlide();
      });
      $("section.tech .controls .left").on("click", function(e) {
        e.preventDefault();
        tech.goToPrevSlide();
      });
    } else if ($(window).width() > 768) {
      var tech = $("section.tech .slider.desktop").bxSlider({
        slideWidth,
        minSlides: 2,
        maxSlides: 3,
        moveSlides: 1,
        pager: true,
        controls: false,
        slideMargin: 0,
        shrinkItems: true,
        auto: false,
        infiniteLoop: true,
        preventDefaultSwipeY: false,
      });

      $("section.tech .controls .right").on("click", function(e) {
        e.preventDefault();
        tech.goToNextSlide();
      });
      $("section.tech .controls .left").on("click", function(e) {
        e.preventDefault();
        tech.goToPrevSlide();
      });
    } else {
      $("section.tech .slider.mobile").bxSlider({
        slideWidth,
        minSlides: 1,
        maxSlides: 2,
        moveSlides: 1,
        pager: true,
        controls: false,
        auto: false,
        preventDefaultSwipeY: false,
        infiniteLoop: true,
        // shrinkItems: true,
        onSliderLoad: function() {
          var height = 0;
          var slides = $("section.tech .slider.mobile .slideCont");
          $.each(slides, function(i, s) {
            var sHeight = $(s)
              .find(".textMobile")
              .outerHeight();
            if (sHeight > height) height = sHeight;
          });
          $(".textMobile").css("height", height + "px");
        },
      });
    }

    var specs;

    var slideWidthSpecs;
    if ($(window).width() > 768) {
      slideWidthSpecs = 500;
    } else if ($(window).width() > 600) {
      slideWidthSpecs = 400;
    } else {
      slideWidthSpecs = 330;
    }
        
    let draggable = $("section.specs .model").length > 1 ? true: false;
    if ($(window).width() > 768) {
      specs = $("section.specs .models").bxSlider({
        slideWidth: slideWidthSpecs,
        minSlides: 3,
        maxSlides: 3,
        moveSlides: 1,
        pager: false,
        controls: false,
        auto: false,
        preventDefaultSwipeY: false,
        shrinkItems: true,
        touchEnabled: draggable
      });
    } else {
      specs = $("section.specs .models").bxSlider({
        slideWidth: slideWidthSpecs,
        minSlides: 1,
        maxSlides: 2,
        moveSlides: 1,
        pager: false,
        controls: false,
        infiniteLoop: true,
        auto: false,
        preventDefaultSwipeY: false,
        shrinkItems: false,
        touchEnabled: draggable
        
      });
    }

    $("section.specs .arrow.right").on("click", function(e) {
      e.preventDefault();
      specs.goToPrevSlide();
    });
    $("section.specs .arrow.left").on("click", function(e) {
      e.preventDefault();
      specs.goToNextSlide();
    });

    var pagerType;
    if ($(window).width() > 768) pagerType = "full";
    else pagerType = "short";

    var slideGalleriaInterior = $(
      ".slideshow.galleria_interior .sliderCont"
    ).bxSlider({
      mode: "fade",
      pager: true,
      controls: false,
      auto: false,
      pagerType,
      adaptiveHeight: true,
      preventDefaultSwipeY: false,
      shrinkItems: true,
    });

    $(".slideshow.galleria_interior .arrow.right").on("click", function(e) {
      e.preventDefault();
      slideGalleriaInterior.goToNextSlide();
    });
    $(".slideshow.galleria_interior .arrow.left").on("click", function(e) {
      e.preventDefault();
      slideGalleriaInterior.goToPrevSlide();
    });

    var slideGalleriaExterior = $(
      ".slideshow.galleria_exterior .sliderCont"
    ).bxSlider({
      mode: "fade",
      pager: true,
      controls: false,
      auto: false,
      pagerType,
      adaptiveHeight: true,
      preventDefaultSwipeY: false,
      shrinkItems: true,
    });

    $(".slideshow.galleria_exterior .arrow.right").on("click", function(e) {
      e.preventDefault();
      slideGalleriaExterior.goToNextSlide();
    });
    $(".slideshow.galleria_exterior .arrow.left").on("click", function(e) {
      e.preventDefault();
      slideGalleriaExterior.goToPrevSlide();
    });

    var slideshowAlternate = $(".slideshow.alternate .sliderCont").bxSlider({
      mode: "fade",
      pager: false,
      controls: false,
      auto: false,
      pagerType,
      adaptiveHeight: true,
      preventDefaultSwipeY: false,
      shrinkItems: true,
    });

    $(".slideshow.alternate .arrow.right").on("click", function(e) {
      e.preventDefault();
      slideshowAlternate.goToNextSlide();
    });
    $(".slideshow.alternate .arrow.left").on("click", function(e) {
      e.preventDefault();
      slideshowAlternate.goToPrevSlide();
    });
  }

  initSliderHome() {
    var self = this;

    
    self.player = {};
    self.nextSliderTimer = null;
/*
    $(document).ready(function(){
      let zoomImagesSlider = gsap.utils.toArray("section.features .sliderCont .zoomImageSlider");

            zoomImagesSlider.forEach((image) => {
            gsap.fromTo(image, {scale: 1},    
                {
                scale: 1.2,
                duration: 0.5,
                scrollTrigger: {
                  trigger: image,      
                  markers: {startColor: "green", endColor: "red", fontSize: "18px", fontWeight: "bold", indent: 20},
                  start: "top center", // when the top of the trigger hits the top of the viewport
                  end: "bottom bottom", // end after scrolling 500px beyond the start
                  scrub: 5, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                }
              });
            });
    })
    */

    var pager = $("section.detail .slider .slide").length > 1;
    window.heroSlider = $("section.detail .slider").bxSlider({
      mode: "fade",
      pager,
      controls: false,
      touchEnabled: false,
      autoStart: false,
      auto: false,
      preventDefaultSwipeY: false,
      minSlides: 1,
      maxSlides: 1,
      moveSlides: 1,
      shrinkItems: true,
      buildPager: function() {
        return '<svg height="30" width="30"> <circle cx="15" cy="15" r="14" stroke="white" stroke-width="1" fill="transparent" /> </svg>';
      },
      onSliderLoad: function(currentIndex) {
        self.showSliderHome(currentIndex);




        let zoomBGHero = gsap.utils.toArray(".imageBGHeroDetail");

        zoomBGHero.forEach((image) => {
        // gsap.fromTo(image,{backgroundSize: '103%',},   
        gsap.fromTo(image,{scale: 1},     
          {
            scale: 1.1,  
            // backgroundSize: '110%',
            duration:1.5,
            scrollTrigger: {
              trigger: image,      
              //markers: {startColor: "green", endColor: "red", fontSize: "18px", fontWeight: "bold", indent: 20},
              start: "center +=30%", // when the top of the trigger hits the top of the viewport
              end: "bottom bottom", // end after scrolling 500px beyond the start
              scrub: 5, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
            }
          });
        });
    
      },
      onSlideAfter: function(dom, oldIndex, newIndex) {
        self.showSliderHome(newIndex);
      },
    });

    $("section.detail .bx-wrapper .bx-pager.bx-custom-pager a").on(
      "click",
      function() {
        $("section.detail .bx-wrapper .bx-pager.bx-custom-pager").addClass(
          "stopAnimation"
        );
      }
    );
  }

  showSliderHome(index) {
    var self = this;

    if (self.nextSliderTimer) {
      clearTimeout(self.nextSliderTimer);
      self.nextSliderTimer = null;
    }

    var dom = $("section.detail .slider .slide").eq(index);
    if (dom.find(".video-wrapper").length == 1) {
        self.player = new YT.Player("player", {
          playerVars: {
            autoplay: 1,
            showinfo: 0,
            autohide: 1,
            loop: 0,
            controls: 0,
            modestbranding: 1,
            rel: 0,
            playsinline: 1
          },
          height: "100%",
          width: "100%",
          videoId: dom.find(".video-wrapper div").data("video"),
          events: {
            onReady: self.YTPlayerReady,
            onStateChange: self.YTStateChange,
          },
        });
    } else {
      self.nextSliderTimer = setTimeout(function() {
        window.heroSlider.goToNextSlide();
      }, 8000);
    }

    
  }

	YTPlayerReady(event) {
		var self=this;
		
		event.target.playVideo();
		event.target.mute(); // comment out if you don't want the auto played video muted
		event.target.seekTo(0);
		
		const currentVideo=event.target;
		const videoTime=currentVideo.getDuration()-2;
		const videoInterval=setInterval(function(){
			if(videoTime<currentVideo.getCurrentTime()){
				clearInterval(videoInterval);
				if($("section.detail .slider .slide").length==1){
					event.target.seekTo(0);
					event.target.playVideo();
					event.target.mute(); // comment out if you don't want the auto played video muted
				}else{
					event.target.pauseVideo();
					setTimeout(function(){
						event.target.destroy();
						window.heroSlider.goToNextSlide();
					}, 500);
				}				
			}
		}, 500);
	}

	YTStateChange(event) {
		var self=this;
		if (event.data == -1) {
			event.target.seekTo(0);
			event.target.mute(); // comment out if you don't want the auto played video muted
			event.target.playVideo();
		}
	}

}

export default CarDetail;
